import Footer from "../components/Footer"
import { Link } from "react-router-dom"
import { ROUTES } from "../Routes";
import { usePageTitle } from "../hooks/usePageTitle";

const TermsPage = () => {
    usePageTitle('Terms of Service');
  return (
    <>
      <section className="page-header">
        <h1>📜 TERMS OF SERVICE 📜</h1>
        <p style={{ color: '#66ff66', fontSize: '1.2rem' }}>
          Please read carefully
        </p>
        <Link to="/" className="back-button">
          ← BACK TO HOME
        </Link>
      </section>

      <div className="content-container">
        <div className="terms-box">

          <h2>1. ACCEPTANCE OF TERMS</h2>
          <p>
            By accessing and using noravo.site, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use this website.
          </p>

          <h2>2. DESCRIPTION OF SERVICE</h2>
          <p>
            noravo.site is a FREE entertainment platform that simulates social casino games. We provide this service for entertainment and educational purposes only.
          </p>

          <div className="highlight-box">
            <p><strong>⚠️ CRITICAL INFORMATION:</strong></p>
            <p>
              This platform involves NO REAL MONEY. All games use virtual credits with zero monetary value. You cannot win or lose real money on this platform.
            </p>
          </div>

          <h2>3. USER ELIGIBILITY</h2>
          <p>
            Users must be 18 years of age or older to access this platform. By using this website, you represent that you are of legal age in your jurisdiction.
          </p>

          <h2>4. NO GAMBLING</h2>
          <p>
            noravo.site is NOT a gambling website. We do not:
          </p>
          <ul>
            <li>Accept real money deposits</li>
            <li>Offer real money prizes or payouts</li>
            <li>Facilitate any form of real money wagering</li>
            <li>Provide gambling services of any kind</li>
          </ul>

          <h2>5. USER CONDUCT</h2>
          <p>Users agree to:</p>
          <ul>
            <li>Use the platform for lawful purposes only</li>
            <li>Not attempt to hack, exploit, or damage the website</li>
            <li>Not use automated systems to access the platform</li>
            <li>Respect the intellectual property rights of the platform</li>
          </ul>

          <h2>6. INTELLECTUAL PROPERTY</h2>
          <p>
            All content on noravo.site, including but not limited to text, graphics, logos, and software, is the property of the platform or its content suppliers and is protected by copyright laws.
          </p>

          <h2>7. DISCLAIMER OF WARRANTIES</h2>
          <p>
            This platform is provided "as is" without any warranties, express or implied. We do not guarantee that the service will be uninterrupted, secure, or error-free.
          </p>

          <h2>8. LIMITATION OF LIABILITY</h2>
          <p>
            noravo.site and its creators shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use this platform.
          </p>

          <h2>9. MODIFICATIONS TO SERVICE</h2>
          <p>
            We reserve the right to modify or discontinue the service at any time without notice. We shall not be liable to you or any third party for any modification or discontinuation of the service.
          </p>

          <h2>10. CHANGES TO TERMS</h2>
          <p>
            We reserve the right to update these Terms of Service at any time. Your continued use of the platform after changes constitutes acceptance of the modified terms.
          </p>

          <h2>11. RESPONSIBLE GAMING</h2>
          <p>
            While this platform involves no real money, we encourage responsible entertainment habits. If you or someone you know has a gambling problem, please visit our
            <Link to={ROUTES.RESPONSIBLE} style={{ color: '#00ff00' }}>Responsible Gaming</Link> page for resources.
          </p>

          <h2>12. CONTACT INFORMATION</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
            <a href="mailto:support@hrtechit.com" style={{ color: '#00ff00' }}>support@hrtechit.com</a>
          </p>

          <h2>13. GOVERNING LAW</h2>
          <p>
            These Terms of Service shall be governed by and construed in accordance with applicable laws. Any disputes arising from these terms shall be resolved in accordance with the laws of the relevant jurisdiction.
          </p>

          <div className="last-updated">
            <p>Last Updated: December 2025</p>
            <p>Effective Date: December 2025</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default TermsPage